<template>
      <BreadCrumb PageTitle=" Modifier une place" />
    <EditPlace />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditPlace from "@/components/Place/EditPlace.vue";
  
    export default defineComponent({
      name: "EditPlacePage",
      components: {
        EditPlace,
        BreadCrumb
      },
    });
  </script>